// 合并所有reducer 并且返回
import { combineReducers } from 'redux'
import { basicInfo } from './basicInfo'

export default combineReducers({
  basicInfo,
})
